<template>
    <div class="reports_map acf-map" id="reports_map"></div>
</template>
<script>
import MarkerClusterer from "@googlemaps/markerclustererplus";
export default {
    props: ["reports"],
    data() {
        return {
            active_marker: null,
            map: "",
            bounds: "",
            markers: [],
            prevInfoWindow: false,
            markerCluster: null
        };
    },
    mounted() {
        this.initMap();
    },

    methods: {
        initMap() {
            let map_zoom = 7;
            if (window.innerWidth < 570) {
                map_zoom = 6;
            }
            this.map = new google.maps.Map(
                document.getElementById("reports_map"),
                {
                    center: { lat: 38.41, lng: 23.05 },
                    fullscreenControl: true,
                    // mapTypeId: 'satellite',
                    // styles: [{"featureType":"administrative","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","elementType":"all","stylers":[{"saturation":-100},{"lightness":"50"},{"visibility":"simplified"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"lightness":"30"}]},{"featureType":"road.local","elementType":"all","stylers":[{"lightness":"40"}]},{"featureType":"transit","elementType":"all","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]},{"featureType":"water","elementType":"labels","stylers":[{"lightness":-25},{"saturation":-100}]}],
                    styles: [
                        {
                            featureType: "administrative",
                            elementType: "labels.text.fill",
                            stylers: [{ lightness: "-8" }]
                        },
                        {
                            featureType: "administrative",
                            elementType: "labels.text.stroke",
                            stylers: [{ weight: "0.01" }, { lightness: "3" }]
                        },
                        {
                            featureType: "administrative.province",
                            elementType: "all",
                            stylers: [{ visibility: "off" }, { weight: "0.01" }]
                        },
                        {
                            featureType: "administrative.province",
                            elementType: "labels.text.stroke",
                            stylers: [{ weight: "0.01" }]
                        },
                        {
                            featureType: "administrative.locality",
                            elementType: "labels",
                            stylers: [{ lightness: "0" }]
                        },
                        {
                            featureType: "administrative.locality",
                            elementType: "labels.text.stroke",
                            stylers: [{ weight: "0.01" }]
                        },
                        {
                            featureType: "administrative.neighborhood",
                            elementType: "labels.text.stroke",
                            stylers: [{ weight: "0.01" }]
                        },
                        {
                            featureType: "administrative.land_parcel",
                            elementType: "geometry.fill",
                            stylers: [{ lightness: "0" }]
                        },
                        {
                            featureType: "administrative.land_parcel",
                            elementType: "labels.text.stroke",
                            stylers: [{ weight: "0.01" }]
                        },
                        {
                            featureType: "landscape",
                            elementType: "all",
                            stylers: [
                                { saturation: -100 },
                                { lightness: 65 },
                                { visibility: "on" },
                                { weight: "0.01" }
                            ]
                        },
                        {
                            featureType: "landscape",
                            elementType: "geometry.fill",
                            stylers: [{ lightness: "-13" }]
                        },
                        {
                            featureType: "landscape.man_made",
                            elementType: "geometry.fill",
                            stylers: [{ lightness: "0" }]
                        },
                        {
                            featureType: "landscape.natural.landcover",
                            elementType: "geometry.fill",
                            stylers: [{ lightness: "-52" }]
                        },
                        {
                            featureType: "landscape.natural.terrain",
                            elementType: "geometry.fill",
                            stylers: [{ lightness: "-42" }]
                        },
                        {
                            featureType: "poi",
                            elementType: "all",
                            stylers: [
                                { saturation: -100 },
                                { lightness: "50" },
                                { visibility: "on" },
                                { weight: "0.01" }
                            ]
                        },
                        {
                            featureType: "poi",
                            elementType: "geometry.fill",
                            stylers: [{ lightness: "-17" }, { weight: "0.01" }]
                        },
                        {
                            featureType: "poi",
                            elementType: "labels.text.stroke",
                            stylers: [{ weight: "0.01" }]
                        },
                        {
                            featureType: "poi.business",
                            elementType: "all",
                            stylers: [{ visibility: "off" }]
                        },
                        {
                            featureType: "poi.government",
                            elementType: "all",
                            stylers: [{ visibility: "on" }, { lightness: "-8" }]
                        },
                        {
                            featureType: "poi.government",
                            elementType: "labels.icon",
                            stylers: [{ visibility: "on" }]
                        },
                        {
                            featureType: "road",
                            elementType: "all",
                            stylers: [
                                { saturation: "-100" },
                                { visibility: "on" },
                                { weight: "1" }
                            ]
                        },
                        {
                            featureType: "road",
                            elementType: "labels.text",
                            stylers: [{ visibility: "on" }]
                        },
                        {
                            featureType: "road",
                            elementType: "labels.icon",
                            stylers: [{ visibility: "off" }]
                        },
                        {
                            featureType: "road.highway",
                            elementType: "all",
                            stylers: [
                                { visibility: "simplified" },
                                { weight: "2" }
                            ]
                        },
                        {
                            featureType: "road.highway",
                            elementType: "geometry.fill",
                            stylers: [{ lightness: "-15" }]
                        },
                        {
                            featureType: "road.highway",
                            elementType: "labels.icon",
                            stylers: [{ visibility: "off" }, { weight: "1" }]
                        },
                        {
                            featureType: "road.arterial",
                            elementType: "all",
                            stylers: [{ lightness: "30" }]
                        },
                        {
                            featureType: "road.arterial",
                            elementType: "geometry.fill",
                            stylers: [{ lightness: "0" }]
                        },
                        {
                            featureType: "road.local",
                            elementType: "all",
                            stylers: [{ lightness: "40" }]
                        },
                        {
                            featureType: "transit",
                            elementType: "all",
                            stylers: [{ color: "#818181" }]
                        },
                        {
                            featureType: "transit.station.rail",
                            elementType: "all",
                            stylers: [{ weight: "7.91" }]
                        },
                        {
                            featureType: "water",
                            elementType: "geometry",
                            stylers: [
                                { hue: "#ffff00" },
                                { lightness: -25 },
                                { saturation: -97 }
                            ]
                        },
                        {
                            featureType: "water",
                            elementType: "labels",
                            stylers: [{ lightness: -25 }, { saturation: -100 }]
                        }
                    ],
                    zoom: map_zoom
                }
            );
        },

        addMarkers() {
            if (this.markerCluster) {
                // this.markerCluster.clearMarkers();
            }
            for (let i = 0; i < this.markers.length; i++) {
                this.markers[i].setMap(null);
            }
            this.markers = [];
            this.bounds = new google.maps.LatLngBounds();
            this.reports.forEach((report, index) => {
                const icon = {
                    url: report.icon.encoded
                        ? report.icon.encoded
                        : report.icon, // url
                    size: new google.maps.Size(
                        report.icon.width ? report.icon.width : 22,
                        report.icon.height ? report.icon.height : 22
                    ),
                    origin: new google.maps.Point(0, 0),
                    scaledSize: new google.maps.Size(
                        22,
                        report.icon.count ? report.icon.count * 22 : 22
                    ), // scaled size
                    anchor: new google.maps.Point(11, 11) // anchor
                };
                let marker = new google.maps.Marker({
                    position: new google.maps.LatLng(report.lat, report.lng),
                    map: this.map,
                    icon: icon,
                    report_id: report.id,
                    report_image: report.main_photo?.thumbnail
                });
                this.markers.push(marker);
                this.bounds.extend(marker.position);

                const contentString = `<a href="${
                    report.url
                }" class="section__grid__item">
          <div class="section__grid__item__image"> <img src="/images/placeholder.jpg" lazyload="true" alt=""> </div>
          <div class="section__grid__item__main">
            <h4 class="section__grid__item__title">${report.name}</h4>
            <div class="section__grid__item__icons">
              <img src="${
                  report.icon.encoded ? report.icon.encoded : report.icon
              }"/>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.26 33.48"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M16.63,33.48A16.74,16.74,0,1,1,33.26,16.74,16.7,16.7,0,0,1,16.63,33.48ZM16.63,2A14.74,14.74,0,1,0,31.26,16.74,14.7,14.7,0,0,0,16.63,2Z"/><polygon points="15.33 25.17 13.94 23.73 20.81 17.07 14.17 10.65 15.56 9.21 23.69 17.07 15.33 25.17"/><rect x="2.04" y="16.19" width="18.98" height="2"/></g></g></svg>
            </div>
          </div>
        </a>`;

                const infowindow = new google.maps.InfoWindow({
                    content: contentString
                });

                google.maps.event.addListener(marker, "click", () => {
                    if (this.prevInfoWindow) {
                        this.prevInfoWindow.close();
                    }
                    infowindow.content.replace("imageurl", marker.report_image);
                    const new_content = infowindow
                        .getContent()
                        .replace(
                            "/images/placeholder.jpg",
                            marker.report_image
                        );
                    infowindow.setContent(new_content);

                    this.prevInfoWindow = infowindow;
                    infowindow.open(this.map, marker);
                });
            });
            // this.markerCluster = new MarkerClusterer(this.map, this.markers);
        },

        showReportWindow() {}
    },

    watch: {
        reports: {
            // watch it
            handler(val) {
                this.addMarkers();
            },
            deep: true
        }
    }
};
</script>
